import { useMutation } from '@tanstack/react-query';
import { requestCreateAccount } from '../createAccount/createAccount';
import { CreateAccountRequest } from '../createAccount/types/createAccountRequest';

export function useCreateAccount() {
    return useMutation({
        mutationFn: async (data: CreateAccountRequest) => (await requestCreateAccount(data)).data,
        onSuccess: async data => {
            // queryClient.invalidateQueries();
        },
    });
}
